import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Form, Button, notification } from 'antd';
import { getInitialValues, getDiffValues } from './utils';
import { SUCCESS_MSG, FAILURE_MSG, MSG_TITLE } from './constants';
import FormItem from './formItem';
import style from './index.scss';

const TRMConfiguration = ({
  configurations = [],
  apiActions = {},
  isLoading,
  isSaved,
  hasError
}) => {
  const formRef = useRef();
  const {
    getTRMConfigurations,
    unMountTRMConfigurations,
    putTRMConfigurations
  } = apiActions;

  useEffect(() => {
    getTRMConfigurations();
  }, []);

  useEffect(() => () => unMountTRMConfigurations(), []);

  useEffect(() => {
    if (!isEmpty(configurations)) {
      formRef.current.setFieldsValue(getInitialValues(configurations));
    }
  }, [configurations]);

  const onFinish = (values) => {
    const payload = getDiffValues(values, getInitialValues(configurations));
    if (isEmpty(payload)) {
      return;
    }
    putTRMConfigurations({ data: payload });
  };

  if (isSaved) {
    notification['success']({
      message: MSG_TITLE,
      description: SUCCESS_MSG,
      duration: 2
    });
  }

  if (hasError) {
    notification['error']({
      message: MSG_TITLE,
      description: FAILURE_MSG,
      duration: 2
    });
  }

  return (
    <div className={style.mainContainer}>
      <div className={style.titleContainer}>
        <p className={style.pageTitle}>System Configuration</p>
      </div>
      <div>
        <div className={style.bodyContainer}>
          <div className={style.bodyPanelContainer}>
            <div className="row">
              <div className="col-md-12">
                <Form
                  name="configuration"
                  layout="vertical"
                  ref={formRef}
                  requiredMark={false}
                  onFinish={onFinish}>
                  <FormItem confKey="TDSS_BASE_URL" />
                  <FormItem confKey="TDSS_CREDENTIAL_TOKEN" />
                  <FormItem confKey="TDSS_EXECUTION_ROUTE" />
                  <FormItem confKey="RUN_INSTANCE_PIPELINE_ID" type="number" />
                  <FormItem confKey="TDSS_PIPELINE_INSTANCE_STATUS_ROUTE" />
                  <FormItem confKey="TDSS_PRODUCT_ID" type="number" />
                  <FormItem confKey="TRAINING_PIPELINE_ID" type="number" />
                  <FormItem
                    confKey="PREDICTION_INSTANCE_PIPELINE_ID"
                    type="number"
                  />
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={isLoading}>
                      Save
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TRMConfiguration.propTypes = {
  configurations: PropTypes.array,
  apiActions: PropTypes.object,
  isLoading: PropTypes.bool,
  isSaved: PropTypes.bool,
  hasError: PropTypes.bool
};

export default TRMConfiguration;
